import { cn } from "@/lib/utils";

export function LogoMark({ size = 28, className, ...props }) {
  return (
    <img
      src="/brand/chatsleek-mark.png"
      alt="ChatSleek"
      width={size}
      height={size}
      draggable={false}
      className={cn("select-none object-contain shrink-0", className)}
      style={{ width: size, height: size }}
      {...props}
    />
  );
}

export function Wordmark({ className }) {
  return <span className={cn("text-[19px] font-semibold tracking-tight text-white", className)}>ChatSleek</span>;
}

export function BrandLockup({ size = 30, className }) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)} data-testid="brand-lockup">
      <LogoMark size={size} />
      <Wordmark />
    </span>
  );
}
